(() => {
  'use strict';
  const KEY = 'swapwear:acquisition:v1';
  const VISITOR_KEY = 'swapwear:acquisition:visitor';
  const initial = window.__initialData;
  if (!initial || window.Shopify?.designMode) return;
  const regularProfile = JSON.parse(JSON.stringify(initial.sale_profile));
  const regularMystery = { ...initial.mystery_data?.[2] };
  const landing = /\/pages\/build-bundle-bases\/?$/.test(location.pathname);
  const root = () => window.Alpine?.$data(document.documentElement) || initial;
  const read = key => { try { return JSON.parse(localStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  let claim = read(KEY);
  let visitorId = read(VISITOR_KEY);
  let busy = false;
  let retry = null;
  let clockOffset = 0;
  let activeCode = '';
  let refreshPromise = null;
  let resolving = 0;
  window.swapwearCurrentOffer = () => {
    const app = root();
    return { profile: app.sale_profile, gift: app.mystery_data?.[2], pending: app.acquisition_resolving === true };
  };
  function resolveOffer(delta) {
    resolving = Math.max(0, resolving + delta);
    root().acquisition_resolving = resolving > 0;
    window.dispatchEvent(new CustomEvent('swapwear:promo-changed'));
  }
  const now = () => Date.now() + clockOffset;
  const active = value => value?.active === true && value.firstOrderOnly === true && /^SWNEW-[A-F0-9]{32}$/.test(value.code || '') && Date.parse(value.endsAt) > now() && Date.parse(value.startsAt) <= now() && Date.parse(value.endsAt) - Date.parse(value.startsAt) <= 7 * 24 * 60 * 60 * 1000;
  const route = path => `${window.Shopify?.routes?.root || '/'}${path}`;

  async function requestJson(path, options = {}, transport = fetch) {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    let timeout;
    try {
      return await Promise.race([
        transport(route(path), { ...options, ...(controller ? { signal: controller.signal } : {}) }).then(response => {
          if (!response.ok) throw new Error('Offer request unavailable');
          return response.json();
        }),
        new Promise((_, reject) => {
          timeout = setTimeout(() => { controller?.abort(); reject(new Error('Offer request timed out')); }, 8000);
        })
      ]);
    } finally { clearTimeout(timeout); }
  }

  function profile(value) {
    const projection = value.projection;
    const offer = projection.offer || {};
    const messaging = projection.messaging || {};
    return { ...regularProfile, acquisition: true, acquisitionCode: value.code, id: 'acquisition', active: true, type: offer.type, tierMode: offer.type === 'sitewide' ? 'panel_and_base' : offer.tier_mode, start: value.startsAt, end: value.endsAt, showTimer: true,
      title: messaging.headline, announcement: messaging.eyebrow, eventLabel: messaging.headline, checkoutLabel: messaging.checkoutLabel, discountLabel: messaging.eyebrow, accordionContent: messaging.subheading, detailLine: messaging.subheading, badge: messaging.badge, beforeTimerMsg: messaging.subheading, ctaLabel: messaging.cta, promoTheme: messaging.theme,
      url: route('pages/build-bundle-bases'), discount: offer.max_percentage_off || offer.percentage_off || 0, messaging, offer,
      tiers: (offer.tiers || []).map(tier => ({ name: tier.title || tier.label, req_art: tier.threshold, req_jackets: offer.tier_mode === 'panel_and_base' ? 1 : 0, discounts_base: offer.tier_mode === 'panel_and_base', discount: tier.percentage_off, label: tier.label, badge: tier.badge })),
      mystery2: offer.mystery_panel?.enabled ? offer.mystery_panel.threshold_panel_quantity : false };
  }

  function setProfile(next, mystery) {
    const app = root();
    Object.assign(app.sale_profile, next);
    if (app.mystery_data?.[2]) Object.assign(app.mystery_data[2], mystery);
    window.dispatchEvent(new CustomEvent('swapwear:promo-changed', { detail: { acquisition: next.acquisition === true } }));
  }

  async function applyCode(code) {
    const cart = await requestJson('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) }, window.swapwearFetch || fetch);
    window.swapwearFetch?.confirmCart(cart);
    const app = root();
    if (app.cart) Object.assign(app.cart, cart);
  }

  async function activate(value) {
    if (!active(value) || !value.projection?.offer) return;
    resolveOffer(1);
    try {
      if (activeCode !== value.code) await applyCode(value.code);
      if (!active(value)) return;
      activeCode = value.code;
      const next = profile(value);
      const mystery = next.offer.mystery_panel;
      setProfile(next, { ...regularMystery, active: Boolean(mystery?.enabled), req: Number(mystery?.threshold_panel_quantity || 0), rewardVariantId: mystery?.reward_variant_id || '', popup: false });
      tick();
      await root().updateCart?.(false);
    } finally { resolveOffer(-1); }
  }

  async function restore() {
    resolveOffer(1);
    try {
      const regularActive = regularProfile.active === true && (!regularProfile.start || Date.parse(regularProfile.start) <= now()) && (!regularProfile.end || Date.parse(regularProfile.end) > now());
      setProfile({ ...regularProfile, active: regularActive, acquisition: false, acquisitionCode: '' }, { ...regularMystery, active: regularActive && regularMystery.active });
      if (!activeCode && !claim?.code) return;
      const expiredCode = activeCode || claim?.code;
      activeCode = '';
      const cart = await requestJson('cart.js', { headers: { Accept: 'application/json' } }, window.swapwearFetch || fetch);
      const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      if (codes.some(entry => entry.code?.toUpperCase() === expiredCode)) {
        await applyCode(codes.filter(entry => entry.code?.toUpperCase() !== expiredCode).map(entry => entry.code).join(','));
      }
      await root().updateCart?.(false);
    } finally { resolveOffer(-1); }
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function setHidden(element, value) {
    if (element && element.hidden !== value) element.hidden = value;
  }

  function renderStatus() {
    const live = Boolean(activeCode && active(claim));
    const expired = claim?.expired === true || Boolean(claim?.endsAt && Date.parse(claim.endsAt) <= now());
    document.querySelectorAll('[data-acquisition-status]').forEach(element => {
      setHidden(element, !live && !expired);
      if (element.hidden) return;
      const offer = claim?.projection?.offer || {};
      const percentage = Number(offer.percentage_off || offer.max_percentage_off || 0);
      setText(element.querySelector('[data-acquisition-headline]'), expired ? 'Your first-order offer has expired' : `${percentage}% OFF`);
      const gift = offer.mystery_panel;
      const giftLabel = element.querySelector('[data-acquisition-gift]');
      setText(giftLabel, !expired && gift?.enabled ? `with ${gift.threshold_panel_quantity} paid art panels` : '');
      const giftRow = element.querySelector('[data-acquisition-gift-row]');
      setHidden(giftRow, expired || !gift?.enabled);
      const products = element.querySelector('[data-acquisition-products]');
      setHidden(products, expired);
      const timer = element.querySelector('.custom-sale-timer-badge');
      setHidden(timer, expired);
      setText(element.querySelector('[data-acquisition-terms]'), expired
        ? 'This deadline does not restart. Current store pricing applies.'
        : `First order only. No minimum panel quantity for ${percentage}% off. ` +
          (gift?.enabled ? `One free Mystery Panel with ${gift.threshold_panel_quantity} paid art panels. ` : '') +
          'Cannot combine with other promotions. Eligibility confirmed at checkout.');
      let deadline = '';
      if (claim?.endsAt) {
        const zone = claim.timeZone || 'UTC';
        deadline = (expired ? 'Ended ' : 'Ends ') + new Intl.DateTimeFormat('en-US', {
          dateStyle: 'medium', timeStyle: 'short', timeZone: zone
        }).format(new Date(claim.endsAt)) + ` (${zone}).`;
      }
      setText(element.querySelector('[data-acquisition-deadline]'), deadline);
    });
  }

  function tick() {
    const remaining = activeCode && active(claim) ? Math.max(0, Date.parse(claim.endsAt) - now()) : 0;
    const hoursRemaining = remaining / 3600000;
    const seconds = Math.ceil(remaining / 1000);
    const formatted = hoursRemaining > 72 ? initial.saleDeadlineCopy.limitedTimeOnly
      : hoursRemaining > 24 ? initial.saleDeadlineCopy.endsSoon
        : [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
    document.querySelectorAll('[data-acquisition-countdown]').forEach(element => { setText(element, formatted); });
    document.querySelectorAll('[data-acquisition-countdown-prefix]').forEach(element => { setHidden(element, !remaining || hoursRemaining > 24); });
    renderStatus();
    if (activeCode && !remaining) { claim = { ...claim, expired: true }; write(KEY, claim); restore().catch(() => {}); }
  }

  async function refresh() {
    if (busy) return refreshPromise;
    if (Number(initial.acquisition_customer_orders) > 0) { await restore(); return; }
    if (!visitorId && !landing) return;
    if (!visitorId) { visitorId = crypto.randomUUID(); write(VISITOR_KEY, visitorId); }
    busy = true;
    resolveOffer(1);
    refreshPromise = (async () => {
      try {
        if (active(claim)) await activate(claim);
        const value = await requestJson('apps/promo-planner/acquisition', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ visitorId, enroll: landing, groupedCodes: true }) });
        if (value.serverNow) clockOffset = Date.parse(value.serverNow) - Date.now();
        if (value.preparing === true && Date.parse(value.endsAt) > now()) {
          clearTimeout(retry);
          retry = setTimeout(refresh, 1000);
          return;
        }
        clearTimeout(retry);
        if (active(value)) {
          claim = value; write(KEY, value);
          await activate(value);
        } else {
          await restore();
          claim = { ...claim, ...value, active: false, expired: value.expired === true || claim?.expired === true }; write(KEY, claim); renderStatus();
        }
      } catch (_) {
        if (!active(claim)) await restore().catch(() => {});
        clearTimeout(retry); retry = setTimeout(refresh, 30000);
      } finally { busy = false; resolveOffer(-1); }
    })();
    window.swapwearAcquisitionReady = refreshPromise;
    return refreshPromise;
  }

  window.addEventListener('storage', event => {
    if (event.key === VISITOR_KEY) {
      const nextVisitor = read(VISITOR_KEY);
      if (nextVisitor && nextVisitor !== visitorId) { visitorId = nextVisitor; refresh(); }
      return;
    }
    if (event.key !== KEY) return;
    claim = read(KEY);
    if (active(claim)) activate(claim).catch(() => {});
    else restore().catch(() => {});
    tick();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { tick(); refresh(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('online', refresh);
  setInterval(tick, 1000);
  refresh();
})();
